import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopShopify = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const shopifyFeatures = [
        {
            id: 1,
            image: "/assets/software-partners/shopify/inventory-sync.webp",
            title: "Inventory sync",
            desc: "Link your brick-and-mortar store/warehouse inventory with Shopify. All in-store & online sales will automatically update inventory on both platforms.",
            bgColor: "#8ae4f626",
            imageHeight: "30rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "QueueBuster automatically updates inventory levels across your physical store and online Shopify store after every sale, ensuring you always have accurate stock counts.",
                "Gain complete control over your inventory with real-time insights. You'll always know exactly how much stock you have on hand, both in-store and online.",
            ]
        },
        {
            id: 2,
            image: "/assets/software-partners/shopify/central-management.svg",
            title: "Central management",
            desc: "Increase efficiency with central management. Update any of your customer, inventory or product details in either system and it will instantly reflect everywhere.",
            bgColor: "#F2FDEB",
            imageHeight: "46rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Save time and avoid errors with centralized data management. Update any customer, inventory, or product details in QueueBuster, and it will instantly reflect across all your connected systems.",
                "No more worrying about inconsistencies between your online store and physical store. QueueBuster ensures everything is always up-to-date.",
            ]
        },
        {
            id: 3,
            image: "/assets/software-partners/shopify/multi-store-pos.svg",
            title: "Multi-store POS",
            desc: "QueueBuster POS is a multi-store POS & retail management solution. Add more locations at any time with a click of a button. It grows with your business.",
            bgColor: "#FCF7FF",
            imageHeight: "20rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                "Easily add new locations as your business grows with just a click, and gain a comprehensive view of sales performance across your entire retail store network.",
                "Whether you have one store or multiple locations, the system can adapt to your needs, ensuring you have the tools you need to succeed as you expand.",
            ]
        },
    ];

    const shopifyFAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS integrate with Shopify for inventory management?
                </span>
            ),
            des: "QueueBuster POS syncs your brick-and-mortar store or warehouse inventory with Shopify, ensuring that all sales, whether in-store or online, automatically update inventory levels on both platforms.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I manage customer details centrally across QueueBuster POS and Shopify?
                </span>
            ),
            des: "Yes, you can. With central management, any updates made to customer information, inventory, or product details in either QueueBuster POS or Shopify instantly reflect across both systems.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Is QueueBuster POS suitable for multi-store businesses?
                </span>
            ),
            des: "Absolutely. QueueBuster POS is designed as a multi-store POS and retail management solution. You can effortlessly add more locations as your business expands, all with just a click.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What happens when orders are placed on my Shopify store?
                </span>
            ),
            des: "Orders placed on your Shopify store are seamlessly synced to QueueBuster POS. This integration allows you to offer in-store pick-up, and exchanges, and even enables customers to pay in-store upon pickup.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS help with real-time analytics?
                </span>
            ),
            des: "With QueueBuster POS, you get comprehensive in-store and online sales analytics in real time. This makes financial and analytical reporting more accessible and efficient.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                     Can I track sales performance across different locations with QueueBuster POS?
                </span>
            ),
            des: "Yes, QueueBuster POS provides insights into sales performance across all your locations, allowing you to analyze and optimize operations based on real-time data.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Does QueueBuster POS support contactless payments and digital receipts?
                </span>
            ),
            des: "QueueBuster POS supports contactless payment options and enables you to issue digital receipts, offering a modern and convenient checkout experience for customers.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How secure is the integration between QueueBuster POS and Shopify?
                </span>
            ),
            des: "The integration between QueueBuster POS and Shopify is secure and compliant with industry standards, ensuring the protection of sensitive customer and business data.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize QueueBuster POS to suit my business needs?
                </span>
            ),
            des: "Yes, QueueBuster POS is customizable to adapt to your specific business requirements, including customizing receipts, product categories, and user permissions.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is technical support available for QueueBuster POS integration with Shopify?
                </span>
            ),
            des: "Yes, QueueBuster POS offers technical support to assist you with the seamless integration with Shopify and address any queries or issues you may encounter.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section} style={{ alignItems: "end" }}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/SHOPIFY.webp" alt="shopify" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Shopify POS Integration</span><br />
                        <span className={styles.blue_text}> Made Easier</span><span className={styles.black_text}> and</span><br /><span className={styles.blue_text}>Faster with QueueBuster</span>
                    </h1>
                    <p className={styles.page_desc}>Begin selling your Shopify products in-store seamlessly with QueueBuster POS billing software, and transform your retail outlets into trending destinations with connected Shopify POS integration.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "43rem", width: "60rem" }}><Image src="/assets/software-partners/shopify/hero-img.webp" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3>Access the Shopify Solution Integrated with QueueBuster POS</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                {/* <h2>Access the Shopify Solution Integrated with QueueBuster POS</h2> */}
                <HardwareFeatures features={shopifyFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={shopifyFAQ} heading={"FAQs for QueueBuster POS Shopify Integration"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopShopify